import type { Client } from '@peloton/api/utils';
import { pipeData } from '@peloton/api/utils';
import { toMembersList } from '@engage/members/api';

const MAX_RESULTS = 40;

const toSearchUrl = (usernamePrefix: string) =>
  `api/user/search?user_query=${usernamePrefix}&limit=${MAX_RESULTS}`;

export const fetchSearchResults = (api: Client, usernamePrefix: string) =>
  api.get(toSearchUrl(usernamePrefix)).then(pipeData(toMembersList));
